import { render, staticRenderFns } from "./Poll.vue?vue&type=template&id=f6f32df4&scoped=true&"
import script from "./Poll.vue?vue&type=script&lang=ts&"
export * from "./Poll.vue?vue&type=script&lang=ts&"
import style0 from "./Poll.vue?vue&type=style&index=0&id=f6f32df4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f32df4",
  null
  
)

export default component.exports